import {Injectable} from '@angular/core';
import {GridLayoutService} from '@irb-common/interfaces/grid-layout.service';
import {DeletePortfolioDialogComponent} from "@irb/irb-clients/delete-portfolio-dialog/delete-portfolio-dialog.component";

@Injectable({
    providedIn: 'root'
})
export class DeletePortfolioDialogGridLayoutService implements GridLayoutService<DeletePortfolioDialogComponent> {
    constructor() {
    }

    getFrameworkComponents() {
        return {};
    }

    getColumnDefs() {
        return [{
            headerName: 'Portfolio',
            field: 'portfolioName',
            maxWidth: 500,
            width: 500,
            sort: 'asc'
        },
            {
                headerName: 'Total Accounts',
                field: 'acctQty',
                maxWidth: 150,
                width: 150
            }];
    }
}
